import { useCallback, useEffect } from 'react';
var useOnKeyupOutside = function (refs, handler) {
    var listener = useCallback(function (event) {
        var target = event.target;
        if (target && refs.some(function (ref) { return !ref.current || ref.current.contains(target); })) {
            return;
        }
        handler(event);
    }, [refs, handler]);
    useEffect(function () {
        // add listeners in capture mode to prevent the target being removed from DOM
        // tree before we have had a chance to check whether the ref contains it
        document.addEventListener('keyup', listener, true);
        return function () {
            document.removeEventListener('keyup', listener, true);
        };
    }, [listener]);
};
export default useOnKeyupOutside;
//# sourceMappingURL=use-on-keyup-outside.js.map